import NoImage from "../../Assets/images/no-image-4.png";
import { Tooltip } from "react-tooltip";
export default function Image({ url, altName }) {
  return (
    <>
      <img
        src={url}
        data-tooltip-id="img-tip"
        data-tooltip-content={url}
        data-tooltip-place="left"
        data-tooltip-variant="light"
        alt={altName}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = NoImage;
        }}
      />
      <Tooltip
        id="img-tip"
        className="img-tool-tip"
        closeOnScroll={true}
        closeOnEsc={true}
        render={({ content }) => (
          <>
            <img
              src={content}
              //   onError={(e) => {
              //     e.target.onerror = null;
              //     e.target.src = NoImage;
              //   }}
            />
          </>
        )}
      ></Tooltip>
    </>
  );
}
